import React from 'react'
import '../App.css'
import { Title } from './Title'

import './BackgroundSection.css'

const STYLES = [
  'background--first',
  'background--second',
  'background--third',
  'background--forth',
  'background--fifth',
  'background--sixth',
  'background--seventh',
  'background--eigth',
  'background--ninth',
]

function BackgroundSection({ children, type, backgroundStyle }) {
  const checkBackgroundStyle = STYLES.includes(backgroundStyle)
    ? backgroundStyle
    : STYLES[0]

  return (
    <div className={`background ${checkBackgroundStyle}`} type={type}>
      <Title className='title' titleStyle='title--opa' titleSize='title--large'>
        {children}
      </Title>
    </div>
  )
}

export default BackgroundSection
